import { withTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import Offcanvas from "@components/core/Offcanvas";
import Button from "@components/core/Button";
import { getProductReviews } from "@utils/call-api/reviews-call";
import ProductGlobalRating from "../Shared/ProductGlobalRating";
import ProductFits from "../Shared/ProductFits";
import ProductReviewCard from "../Shared/ProductReviewCard";

function ProductReviewsOffcanvas({ product, opened, close, t }) {
  const [reviews, setReviews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  const isNextPageAvailable = pagination.current_page < pagination.total_pages;

  async function getReviews(page) {
    if (loading) return;

    try {
      setLoading(true);
      const res = await getProductReviews(product.id, page, false);

      setPagination({ ...res.meta.pagination, productId: product.id });
      if (page === 1) {
        setReviews(res.data);
      } else {
        setReviews([...reviews, ...res.data]);
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    function getReviewsFirstPage() {
      if (!opened || product.id === pagination.productId) return;

      getReviews(1);
    }

    getReviewsFirstPage();
  }, [opened, product.id]);

  return (
    <Offcanvas
      title={t("product:reviews_title")}
      show={opened}
      onHide={close}
      placement="bottom"
    >
      <div className="container product-reviews-offcanvas">
        <div className="py-4 mt-md-2">
          <ProductGlobalRating
            globalRating={product.global_rating}
            ratingsCount={product.ratings_count}
            size="24px"
            className="flex-column gap-1"
          />
        </div>

        {!!product.recommendations && (
          <div className="mb-4 w-100 d-flex flex-column align-items-center">
            <p className="font-weight-bold mb-3 text-center">
              {t("product:size_advice_section_title")}
            </p>
            <div className="product-fits-container">
              <ProductFits product={product} />
            </div>
          </div>
        )}

        <div className="d-flex flex-column gap-3 w-100">
          {reviews.map((review) => (
            <ProductReviewCard
              key={review.id}
              review={review}
              className="reviews-offcanvas"
            />
          ))}
        </div>

        {isNextPageAvailable && (
          <div className="pt-4 pt-md-5">
            <Button
              variant="outline-primary"
              onClick={() => getReviews(pagination.next_page)}
            >
              {t("product:load_more")}
            </Button>
          </div>
        )}
      </div>
    </Offcanvas>
  );
}

export default withTranslation("product")(ProductReviewsOffcanvas);
